import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { getContractMaintenanceEndpoint } from '../../../common/endpoints';

export const fetchContractMaintenanceData = createApi(getContractMaintenanceEndpoint, 'GET');

const ContractMaintenance = createSlice({
  name: 'ContractMaintenance',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContractMaintenanceData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContractMaintenanceData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchContractMaintenanceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ContractMaintenance.reducer;